import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { Zap } from 'lucide-react';
export function UniqueMechanism() {
  return <SectionWrapper className="bg-brand-teal text-white" data-id="element-119">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
        <div className="text-center mb-12" data-id="element-121">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/10 text-brand-amber mb-6" data-id="element-122">
            <Zap className="w-8 h-8" data-id="element-123" />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6" data-id="element-124">
            El Método de Micro-Ayunos de Cortisol
          </h2>
        </div>

        <div className="space-y-8 text-lg md:text-xl leading-relaxed text-teal-50" data-id="element-125">
          <p data-id="element-126">
            Este no es un plan de nutrición académica; es un{' '}
            <strong data-id="element-127">interruptor biológico</strong>. En lugar de prohibir grupos
            de alimentos para siempre, utilizamos ventanas de tiempo específicas
            (Micro-Ayunos) coordinadas con alimentos de "baja respuesta
            hormonal".
          </p>

          <div className="bg-white/10 p-8 rounded-2xl border border-white/20 backdrop-blur-sm" data-id="element-128">
            <p className="font-medium text-white" data-id="element-129">
              Al aplicar este protocolo, le envías una señal clara a tu sistema
              nervioso: "La emergencia ha terminado". El resultado es que tu
              cuerpo finalmente suelta el sodio y el agua atrapada, reduciendo
              visualmente tu abdomen en solo 48 horas.
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}